import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const modalContent = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s24,
  },
]);

export const packagesList = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s6,
  },
]);

export const packageName = style([
  {
    color: themeVars.link.idle,

    ':hover': {
      textDecoration: 'underline',
    },
  },
]);

export const buttonsContainer = style([
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: space.s8,
  },
]);

export const emptyPackages = style([
  {
    margin: `${space.s35}px 0`,
  },
]);
